/**
 * Money Formatting Utility
 * Provides consistent money formatting across the theme
 */
window.MoneyFormatter = {
  /**
   * Format money amount (in pence) to currency string
   * @param {number} pence - Amount in pence
   * @returns {string} Formatted money string
   */
  format: function(pence) {
    const amount = pence / 100;
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  },

  /**
   * Parse money string to pence
   * @param {string} moneyString - Money string (e.g., "£29.99")
   * @returns {number} Amount in pence
   */
  parse: function(moneyString) {
    const cleanString = moneyString.replace(/[£$,\s]/g, '');
    return Math.round(parseFloat(cleanString) * 100);
  },

  /**
   * Format money for display in JavaScript
   * @param {number} amount - Amount in pounds
   * @returns {string} Formatted money string
   */
  formatAmount: function(amount) {
    return this.format(amount * 100);
  }
};

/**
 * Helper function for quick money formatting
 * @param {number} pence - Amount in pence
 * @returns {string} Formatted money string
 */
window.formatMoney = function(pence) {
  return window.MoneyFormatter.format(pence);
};

console.log('💰 Money formatter loaded');
